import React from 'react'
import styled from 'styled-components'
import HubLogo from '@App/components/HubLogo'
import ImageContainer from '@Components/ImageContainer'
import { result } from '@Helpers/functional'

class Logo extends React.PureComponent {
  render() {
    const { org, hub, signInContext } = this.props
    const loginLogoURL = hub
      ? this.props.loginLogoURL || result('settings.login_logo_url', hub)
      : ''
    return (
      <React.Fragment>
        {signInContext === 'org' && org && org.avatar_url ? (
          <LogoContainer>
            <div className="px-org-login-container">
              <OrgLogo
                className="px-org-login-org-logo"
                op="contain"
                url={org.avatar_url}
                height={90}
              />
            </div>
          </LogoContainer>
        ) : signInContext === 'hub' && loginLogoURL ? (
          <LogoContainer>
            <div className="px-hub-login-container">
              <HubLogo url={loginLogoURL} useImageContainer />
            </div>
          </LogoContainer>
        ) : null}
      </React.Fragment>
    )
  }
}

const LogoContainer = styled.div`
  margin-bottom: 40px;
  width: 100%;
`
const OrgLogo = styled(ImageContainer)`
  height: 90px;
`

export default Logo
